import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#673ab7', // A vibrant deep purple
    },
    secondary: {
      main: '#ff4081', // A hot pink
    },
    background: {
      default: '#f5f5f5', // Kept it clean
      paper: '#ffffff',
    },
    text: {
      primary: '#333333', // Darker text for better contrast
      secondary: '#555555',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 700, letterSpacing: '-0.5px' },
    h5: { fontWeight: 700 }, // A bit bolder
    h6: { fontWeight: 700 }, // A bit bolder
    button: { textTransform: 'none', fontWeight: 700 }, // Bolder buttons
  },
  shape: {
    borderRadius: 20, // Even more rounded
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0px 8px 25px rgba(0, 0, 0, 0.08)', // A bit more pronounced shadow
          backgroundImage: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          padding: '10px 24px',
          boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-1px)',
            filter: 'brightness(1.15)',
          },
        },
        containedPrimary: { // Style for primary contained buttons
            color: '#fff',
            '&:hover': {
                backgroundColor: '#7e57c2', // A lighter shade on hover
            }
        }
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          backgroundColor: '#f8fafc',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#e2e8f0',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#b2a1d8', // A tint of the primary color
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#673ab7', // Primary color on focus
            borderWidth: '2px', // Make focus more prominent
          },
        },
      }
    },
  },
});

export default theme;
